<template>
  <div class="page map-area-container h-full relative" v-touch:start="onTouch">
    <WFMap
      :project="$WF_PROJECT"
      ref="map"
      :showPathText="false"
      :showPOILogo="true"
      @loaded="mapLoaded"
      class="h-full"
      :POIPopupEnabled="true"
      @poiClicked="poiClicked"
    >
      <template v-slot:poi="slotProps">
        <PopUp
          ref="thpopup"
          :poi="slotProps.poi"
          @showPath="popupClicked"
          @close="closePopup"
          class="th-shadow-xl rounded-xl h-full"
        ></PopUp>
      </template>
    </WFMap>

    <div
      class="absolute lg:bottom-38 bottom-164 right-4 lg:right-24 map-left-menu flex flex-col gap-16 text-right justify-items-end"
    >
      <div class="justify-items-end">
        <div class="th-btn-group flex flex-col">
          <MapHomeBtn
            :showLabel="false"
            class="wf-list-item justify-self-end"
          ></MapHomeBtn>
        </div>
      </div>
      <div class="justify-items-end">
        <WFFloorsMenu
          class="map-floors-menu th-btn-group"
          :currentFloor="currentFloor"
        />
      </div>
      <div class="justify-items-end">
        <WFZoomMenu class="th-btn-group flex flex-col gap-4"></WFZoomMenu>
      </div>

      <div class="justify-items-end">
        <div style="height: 5rem"></div>
      </div>
    </div>

    <div
      class="footer-accessibility-wrapper"
      v-if="!mobile"
      @click="setAccessibleLayout(!accessibleLayout)"
    >
      <div class="flex flex-row">
        <div v-if="!mobile && accessibleLayout">
          <WFLanguagesMenu
            class="languages-accessible-menu rounded-lg gap-12 font-medium"
            :showTitle="true"
            :showFlag="false"
            labelType="code"
          ></WFLanguagesMenu>
        </div>
        <div>
          <div class="footer-accessibility-btn">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
              <path
                d="M320 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM204.5 121.3c-5.4-2.5-11.7-1.9-16.4 1.7l-40.9 30.7c-14.1 10.6-34.2 7.7-44.8-6.4s-7.7-34.2 6.4-44.8l40.9-30.7c23.7-17.8 55.3-21 82.1-8.4l90.4 42.5c29.1 13.7 36.8 51.6 15.2 75.5L299.1 224l97.4 0c30.3 0 53 27.7 47.1 57.4L415.4 422.3c-3.5 17.3-20.3 28.6-37.7 25.1s-28.6-20.3-25.1-37.7L377 288l-70.3 0c8.6 19.6 13.3 41.2 13.3 64c0 88.4-71.6 160-160 160S0 440.4 0 352s71.6-160 160-160c11.1 0 22 1.1 32.4 3.3l54.2-54.2-42.1-19.8zM160 448a96 96 0 1 0 0-192 96 96 0 1 0 0 192z"
              />
            </svg>
            <WFTranslate v-if="accessibleLayout" k="exit-layout"
              >Exit layout</WFTranslate
            >
            <WFTranslate v-if="!accessibleLayout" k="alternative-layout"
              >Alternative layout</WFTranslate
            >
          </div>
        </div>
      </div>
    </div>

    <div class="qr-wrapper flex flex-row" v-if="qr && !mobile && !currentPOI">
      <div class="img-wrapper">
        <img :src="qr" />
      </div>
      <div class="flex-1">
        <WFTranslate k="scan-qr-to-open-in-mobile"
          >Scan QR code to open in mobile</WFTranslate
        >
      </div>
    </div>
    <div
      v-show="loading"
      class="loadin absolute w-full h-fullg top-0 bottom-0 bg-white flex items-center justify-center"
    >
      <div class="loader"></div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import PopUp from "./PopUp.vue";
import QRCode from "qrcode";
import MapHomeBtn from "@/components/MapHomeBtn";

export default {
  components: {
    MapHomeBtn,
    PopUp,
  },
  computed: {
    ...mapState(["currentPOI", "directionsOpened"]),
    ...mapState("wf", ["language", "currentFloor", "reset", "mobile"]),
  },
  data() {
    return {
      qr: null,
      accessibleLayout: false,
      loading: true,
    };
  },
  mounted() {},
  watch: {
    currentPOI() {
      if (this.currentPOI && this.$refs.map) {
        this.$refs.map.showPOIPopup(this.currentPOI, 162, 320);
        this.$store.dispatch('setCurrentPage', 'grouppois');
        if (this.$refs.thpopup) {
          this.$nextTick(() => {
            this.$refs.thpopup.resize();
          });

        }
      }
    },
    reset() {},
    "$store.state.directionsOpened": function () {},
  },
  methods: {
    setAccessibleLayout(bool) {
      this.accessibleLayout = bool;
      this.$emit("accessibleLayoutClick", bool);
    },
    shortcutClicked(nearest) {
      if (nearest) {
        this.$store.dispatch(
          "setPOI",
          this.$store.getters["wf/freezePOI"](nearest)
        );
      }
    },
    mapLoaded() {
      this.loading = false;
      this.$wayfinder.events.on("map-click", (poi) => {
        if (poi && poi.getShowInMenu()) {
          this.$store.dispatch(
            "setPOI",
            this.$store.getters["wf/freezePOI"](poi)
          );
        }
      });
      QRCode.toDataURL(
        `https://vnomap.ltou.lt/projects/main/VilniusAirport/?kiosk=${this.$wayfinder.getKiosk()}&upscale=2`
      ).then((url) => {
        this.qr = url;
      });

      this.$emit("loaded");
    },
    getPOIImage(poi) {
      if (poi.getBackgroundUrl()) return poi.getBackgroundUrl();
      else if (poi.getIconUrl()) {
        return poi.getIconUrl();
      } else {
        return "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
      }
    },
    isPOIImage(poi) {
      if (poi.getBackgroundUrl()) return "image-background";
      else if (poi.getIconUrl()) return "image-logo";
      else return "image-none";
    },
    closePOI() {
      this.$store.dispatch("setPOI", null);
    },
    popupClicked() {
      this.$emit("popupClicked", this.currentPOI);
    },
    closePopup() {
      if (this.$refs.map) {
        this.$refs.map.hidePOIPopup();
      }
    },
    onTouch() {
      this.$wayfinder.run();
    },
    poiClicked (poi) {
      this.$emit('poiClicked', poi)
    }
  },
};
</script>

<style lang="postcss">
.map-area-container {
  background: #dde5f6;

  .languages-accessible-menu {
    margin-right: 10pt;
  }

  .qr-wrapper {
    border-radius: 1.6rem;
    background: #fff;
    width: 35rem;
    height: 10rem;
    position: fixed;
    left: 3rem;
    bottom: 3rem;
    font-size: 1.6rem;

    .img-wrapper {
      img {
        border: 0.8rem solid #0f417c;
        border-radius: 1.2rem;
        height: 10rem;
        width: 10rem;
      }
    }

    label {
      display: block;
      height: 100%;
      align-content: center;
      padding-left: 1.5rem;
    }
  }
}

.map-left-menu {
  .wf-item,
  .wf-list-item {
    border-radius: 50% !important;
  }
}
.wf-poi-popup {
  border-radius: 1.2rem;
  padding: 0 !important;
  width: 27rem !important;
  box-shadow: 0px 24px 24px 0px rgba(0, 0, 0, 0.09);
  height: 32rem !important;
}

.wf-poi-popup-content {
  overflow: hidden;
  display: block;
}

.wf-floors-menu .wf-list {
  display: flex;
  flex-direction: column;
  gap: 0 !important;

  .wf-list-item {
    border-radius: 0% !important;
    border-bottom: 0.1rem solid rgba(211, 218, 230, 1);
  }

  .wf-list-item:first-child {
    border-radius: 50% 50% 0 0 !important;
  }

  .wf-list-item:last-child {
    border-bottom: none;
    border-radius: 0 0 50% 50% !important;
  }
}

.general-info {
  background-color: rgba(255, 255, 255, 0.4);
}

.wf-shortcuts-menu .wf-list {
  display: flex;
  flex-direction: column;
}

.wf-shortcuts-menu .wf-list-item:active {
  background-color: var(--th-primary);

  img {
    filter: invert(1);
  }
}

.wf-yah:active {
  background-color: var(--th-primary);
}

.footer-accessibility-wrapper {
  position: absolute;
  right: 2.4rem;
  bottom: 2rem;
}

.footer-accessibility-btn {
  background: #0f417c;
  border-radius: 32px;
  color: #fff;
  padding: 1.4rem 2rem;
  display: flex;
  align-items: center;

  svg {
    display: inline-block;
    height: 3rem;

    path {
      fill: #fff;
    }
  }

  label {
    display: inline-block;
    font-size: 16px;
    font-weight: 600;
    margin-left: 10px;
    padding-right: 10px;
  }
}

.loading {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100&;
  background-color: white;
}

.loader {
  width: 6rem;
  aspect-ratio: 4;
  background: radial-gradient(
      circle closest-side,
      var(--th-primary) 90%,
      var(--th-primary)
    )
    0 / calc(100% / 3) 100% space;
  border-radius: 3rem;
  margin-left: 0.5rem;
  clip-path: inset(0 100% 0 0);
  animation: l1 1s steps(4) infinite;
}

/* HTML: <div class="loader"></div> */
.loader {
  width: 60px;
  aspect-ratio: 4;
  background: radial-gradient(circle closest-side, #000 90%, #0000) 0 /
    calc(100% / 3) 100% space;
  clip-path: inset(0 100% 0 0);
  animation: l1 1s steps(4) infinite;
}
@keyframes l1 {
  to {
    clip-path: inset(0 -34% 0 0);
  }
}
@keyframes l1 {
  to {
    clip-path: inset(0 -34% 0 0);
  }
}

@media (min-width: 1024px) {
  .map-area-container {
    border-radius: 2.4rem;
  }
}
</style>
